import { getCurrentInstance } from '@vue/composition-api';

const useBasketList = (props) => {
  const { emit } = getCurrentInstance();

  const isLastUnavailableItem = index => index + 1 === props.unavailableItemsLength;

  const getCategoryItem = (product) => {
    let id = '0';
    if (product?.category?.id) {
      id = product.category.id;
    }
    return id;
  };

  const getIsPurchased = productUserStats => productUserStats?.isPurchased ?? false;

  const handlerSpliceItem = (data) => {
    emit('spliceItem', data);
  };

  const handlerRestoreItem = (data) => {
    emit('restoreItem', data);
  };

  const handlerUpdateQuantityItem = (data) => {
    emit('updateQuantityItem', data);
  };

  const handlerMoveToWishList = (data) => {
    emit('moveToWishList', data);
  };

  const handlerRemoveItem = (data) => {
    emit('removeItem', data);
  };

  const handlerClickAuth = () => {
    emit('openAuthModal');
  };

  const handlerClickNotAvailable = (data) => {
    emit('clickNotAvailable', data);
  };

  const handlerClickChangeGift = () => {
    emit('clickChangeGift');
  };

  const handlerClickDeleteUnavailable = () => {
    emit('clickDeleteUnavailable');
  };

  return {
    isLastUnavailableItem,
    handlerSpliceItem,
    handlerRestoreItem,
    handlerUpdateQuantityItem,
    handlerMoveToWishList,
    handlerRemoveItem,
    handlerClickAuth,
    handlerClickNotAvailable,
    handlerClickChangeGift,
    handlerClickDeleteUnavailable,
    getCategoryItem,
    getIsPurchased,
  };
};

export default useBasketList;
